import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "accountTypeName" })
export class AccountTypeNamePipe implements PipeTransform {
  transform(value?: string): string {
    if (value) {
      switch (value) {
        case "DY":
          return "医护工作者";
        case "BDY":
          return "医院账号";
        case "SH":
          return "售后";
        case "SHH":
          return "实施工程师";
        case "FK":
          return "访客";
        case "PD":
          return "配单员";
        case "BA":
          return "医院账号";
        case "DLS":
          return "代理商";
        case "ADMIN":
          return "管理员";
        default:
          return value;
      }
    } else {
      return "";
    }
  }
}
